import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'

import { QA_NAME_CONFIRMATION } from '../../../../../constants/qa'
import { ROUTE_PATH_LIST_RENTAL_PORTAL } from '../../../../../constants/route'
import { useNotification } from '../../../../../hooks'
import { ConfirmationModal } from '../../../../Confirmation'
import {
  getRentalPortalApplicantIdentityLabel,
  patchMockApplicant,
} from '../../../../RentalPortalApplicant'
import { useApplicantProfileContext } from '../useApplicantProfileContext'

import ArchiveIcon from '../../../../../icons/delete.svg'
import RestoreIcon from '../../../../../icons/restore.svg'

// TODO: the applicant archive/restore write goes through the mock until the
// endpoint is declared
export function useApplicantProfileArchiveActions() {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const { handleAddErrorNotification, handleAddSuccessNotification } =
    useNotification()

  const {
    applicantData,
    applicantId,
    handleCloseModal,
    handleEntityReload,
    setModal,
  } = useApplicantProfileContext()

  function addArchiveErrorNotification() {
    handleAddErrorNotification({
      textButtonValue: t('RentalPortal.ListingRetryBtnKey'),
      title: t('RentalPortal.ApplicantProfileArchiveErrorKey'),
      onClickTextButton: handleClickArchive,
    })
  }

  function addRestoreErrorNotification() {
    handleAddErrorNotification({
      textButtonValue: t('RentalPortal.ListingRetryBtnKey'),
      title: t('RentalPortal.ApplicantProfileRestoreErrorKey'),
      onClickTextButton: handleClickRestore,
    })
  }

  function handleSubmitArchive() {
    return patchMockApplicant(applicantId, { archived: true })
      .then(() => {
        handleCloseModal()

        handleAddSuccessNotification('Notification.CommonTitleArchivedKey')

        return navigate(
          `/${ROUTE_PATH_LIST_RENTAL_PORTAL.root}/${ROUTE_PATH_LIST_RENTAL_PORTAL.applicants}`
        )
      })
      .catch(() => {
        handleCloseModal()

        addArchiveErrorNotification()
      })
  }

  function handleSubmitRestore() {
    return patchMockApplicant(applicantId, { archived: false })
      .then(() => {
        handleCloseModal()

        handleAddSuccessNotification('Notification.CommonTitleRestoredKey')

        return handleEntityReload()
      })
      .catch(() => {
        handleCloseModal()

        addRestoreErrorNotification()
      })
  }

  function handleClickArchive() {
    setModal(
      <ConfirmationModal
        actionButtonsProps={{
          submitProps: { beforeIconProps: { Icon: ArchiveIcon } },
          submitText: t('RentalPortal.ApplicantProfileArchiveBtnKey'),
        }}
        description={t(
          'RentalPortal.ApplicantProfileArchiveConfirmationTextKey',
          {
            name: getRentalPortalApplicantIdentityLabel({
              applicant: applicantData,
              t,
            }),
          }
        )}
        qaName={QA_NAME_CONFIRMATION}
        onCancel={handleCloseModal}
        onSubmit={handleSubmitArchive}
      />
    )
  }

  function handleClickRestore() {
    setModal(
      <ConfirmationModal
        actionButtonsProps={{
          submitProps: { beforeIconProps: { Icon: RestoreIcon } },
          submitText: t('RentalPortal.ApplicantProfileRestoreBtnKey'),
        }}
        description={t(
          'RentalPortal.ApplicantProfileRestoreConfirmationTextKey',
          {
            name: getRentalPortalApplicantIdentityLabel({
              applicant: applicantData,
              t,
            }),
          }
        )}
        qaName={QA_NAME_CONFIRMATION}
        onCancel={handleCloseModal}
        onSubmit={handleSubmitRestore}
      />
    )
  }

  return {
    handleClickArchive,
    handleClickRestore,
  }
}
